import { useMediaQuery } from 'react-responsive'
import { LEGACY_MEDIA_QUERIES } from 'styles/breakpoints'
import useBreakpoint from './useBreakpoint'

export const useDesktopMediaQuery = () =>
  useBreakpoint('desktopUp', {
    legacyQuery: LEGACY_MEDIA_QUERIES.desktop
  })

export const useTabletAndAboveMediaQuery = () =>
  useBreakpoint('tabletUp', {
    legacyQuery: LEGACY_MEDIA_QUERIES.tabletAndAbove
  })

export const useMobileMediaQuery = () =>
  useBreakpoint('mobileDown', {
    legacyQuery: LEGACY_MEDIA_QUERIES.mobile
  })

export const useTabletDownMediaQuery = () =>
  useBreakpoint('tabletDown', {
    legacyQuery: LEGACY_MEDIA_QUERIES.tabletDown
  })

export const useNoHoverMediaQuery = () =>
  useMediaQuery({ query: '(hover: none), (pointer: coarse)' })

export const useXlUpMediaQuery = () =>
  useBreakpoint('largeDesktopUp', {
    legacyQuery: LEGACY_MEDIA_QUERIES.xlUp
  })

export const useLgDownMediaQuery = () =>
  useBreakpoint('tabletDown', {
    legacyQuery: LEGACY_MEDIA_QUERIES.lgDown
  })

export const useXlDownMediaQuery = () =>
  useBreakpoint('desktopDown', {
    legacyQuery: LEGACY_MEDIA_QUERIES.xlDown
  })
